import React from 'react';
import { entityCommonsVisibility } from '@/constants/states';
import VisibilityFilterToggles, { visibilityFilter } from './VisibilityFilterToggles';
import FilterToggleButtons from './FilterToggleButtons';

const PublicVisibilityFilterToggles = ({
  commonsMode,
  entity,
  internalFlag,
  privateFlag,
  publicFlag,
  updateFlags,
}) => (
  <VisibilityFilterToggles
    entity={commonsMode ? `${entity}.commons.mode` : entity}
    internalFlag={internalFlag}
    privateFlag={privateFlag}
    updateFlags={(flags) => updateFlags({ ...flags, publicFlag })}
  >
    {commonsMode && (
      <FilterToggleButtons filters={[
        visibilityFilter(
          publicFlag,
          `${entity}.commons.mode`,
          () => updateFlags({ privateFlag, internalFlag, publicFlag: !publicFlag }),
          entityCommonsVisibility.PUBLIC,
        ),
      ]}
      />
    )}
  </VisibilityFilterToggles>
);

export default PublicVisibilityFilterToggles;
